import { render, staticRenderFns } from "./ConflictResolveModal.vue?vue&type=template&id=253c4372"
import script from "./ConflictResolveModal.vue?vue&type=script&lang=js"
export * from "./ConflictResolveModal.vue?vue&type=script&lang=js"
import style0 from "./ConflictResolveModal.vue?vue&type=style&index=0&id=253c4372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports